import React, {useContext} from 'react';
import { Link } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText, IconButton, Divider } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { AuthContext } from '../../AuthContext'; // Import AuthContext from the file where it is defined


const Menu = ({ isOpen, toggleMenu, handleMenuItemClick }) => {
  const user = useContext(AuthContext); // Отримання значення _id з контексту

  const handleLogout = () => {
    fetch('/auth/logout', {
      method: 'POST',
      credentials: 'include' // Включаємо передачу креденцій (кукізи, сесії)
    })
      .then(response => {
        if (response.status === 200) {
          window.location.href = '/';
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <>
      <IconButton onClick={toggleMenu} edge="start" color="inherit" aria-label="menu">
        <MenuIcon />
      </IconButton>
      <Drawer anchor="left" open={isOpen} onClose={toggleMenu}>
        <List>
          <ListItem button component={Link} to="/" onClick={handleMenuItemClick} > {/* Перехід на головну сторінку */}
            <ListItemText primary="Головна" />
          </ListItem>
          <ListItem button component={Link} to="/filters" onClick={handleMenuItemClick}> {/* Перехід на сторінку "About" */}
            <ListItemText primary="Налаштування" />
          </ListItem>
          <Divider /> {/* Розділювач */}
          {(user && Object.keys(user).length > 0) ? (
            <ListItem button onClick={handleLogout}>
              <ListItemText primary="Вийти" />
            </ListItem>
          ) : (
            <ListItem button component={Link} to="/login">
              <ListItemText primary="Увійти" />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
};

export default Menu;
